import React, { useState, useEffect, memo } from "react";
import {
    TextField,
    Button,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import PropTypes from "prop-types";
import {
    reservations as reservationsFields,
    reservations_asu as reservationsASUFields,
    subscriptions as subscriptionsFields,
    message_logs as messageLogsFields,
    purchased_services as purchasedServicesFields,
    users as usersFields,
    refund as refundFields,
} from "../../datasource/schema/index";
import {
    SEARCH_FIELDS_DEFAULT,
    COMPARE_VALUES,
    COMPARE_STRINGS_ARR,
    ENTITIES_WITH_COMPARE,
    DEFAULT_GET_PARAMS,
    DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
    SEARCH_FIELD_TYPES,
    MATERIAL_UI_PROPS,
    SHOW_DATE_FORMAT,
    STATE_DATE_FORMAT,
    REGEX_FOR_ALL_BLANKS,
    REGEX_FOR_MULTIPLE_SPACES,
} from "../../lib/data";
import client from "../../config/client";
import styles from "./FilterComponent.module.css";

const buttonTypes = {
    startSearch: {
        name: "Поиск",
        backgroundColor: "#DE210B",
        color: "#FFF",
        width: 91,
        margin: "0 10px",
    },
    dropFilters: {
        name: "Сбросить",
        backgroundColor: "#F5F5F5",
        color: "#9F9F9F",
        width: 116,
        margin: "0 10px",
    },
};

const FilterComponent = (props) => {
    if (props?.globalSearch) {
        const searchEntity = getSearchEntity(props.pathname);

        const [searchParam, setSearchParam] = useState(
            props.globalSearch.search[searchEntity],
        );

        useEffect(() => {
            if (["services"].includes(searchEntity)) {
                setTimeout(() => {
                    const span = Array.from(
                        document.querySelectorAll("span"),
                    ).find((el) => el.textContent.trim() === "Поиск");
                    if (span) {
                        const button = span.closest("button");
                        if (button) {
                            button.click();
                        }
                    }
                }, 1500);
            } else {
                props.initSearch(getMergedParams(props.getParams, searchParam));
            }
        }, []);

        const [savedParams, setSavedParams] = useState({});

        const [compareCreated, setCompareCreated] = useState(
            getDefaultCompare(
                SEARCH_FIELD_TYPES.createdAt.name,
                props.getParams,
            ),
        );
        const [compareStart, setCompareStart] = useState(
            getDefaultCompare(SEARCH_FIELD_TYPES.dateIn.name, props.getParams),
        );
        const [compareEnd, setCompareEnd] = useState(
            getDefaultCompare(SEARCH_FIELD_TYPES.dateOut.name, props.getParams),
        );
        const [compareCheck, setCompareCheck] = useState(
            getDefaultCompare(SEARCH_FIELD_TYPES.total.name, props.getParams),
        );
        const [compareUsingStart, setCompareUsingStart] = useState(
            getDefaultCompare(
                SEARCH_FIELD_TYPES.using_start_date.name,
                props.getParams,
            ),
        );
        const [compareUsingEnd, setCompareUsingEnd] = useState(
            getDefaultCompare(
                SEARCH_FIELD_TYPES.using_end_date.name,
                props.getParams,
            ),
        );

        const [createdAtDate, setCreatedAtDate] = useState(
            startingParameter(
                props.globalSearch.search,
                "created",
                searchEntity,
            ),
        );
        const [startDate, setStartDate] = useState(
            startingParameter(props.globalSearch.search, "start", searchEntity),
        );
        const [endDate, setEndDate] = useState(
            startingParameter(props.globalSearch.search, "end", searchEntity),
        );
        const [usingStartDate, setUsingStartDate] = useState(
            startingParameter(
                props.globalSearch.search,
                "usingStart",
                searchEntity,
            ),
        );
        const [usingEndDate, setUsingEndDate] = useState(
            startingParameter(
                props.globalSearch.search,
                "usingEnd",
                searchEntity,
            ),
        );

        useEffect(() => {
            if (
                searchEntity === "reservations" ||
                searchEntity === "reservations_asu" ||
                searchEntity === "subscriptions"
            ) {
                setCompareCreated(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.createdAt.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.created_at,
                    ),
                );

                setCompareStart(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.dateIn.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.date_in,
                    ),
                );

                setCompareEnd(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.dateOut.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.date_out,
                    ),
                );

                setCompareCheck(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.total.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.total,
                    ),
                );
            }

            if (searchEntity === "rates") {
                setCompareStart(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.dateStart.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.date_start,
                    ),
                );

                setCompareEnd(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.dateEnd.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.date_end,
                    ),
                );
            }

            if (searchEntity === "promo") {
                setCompareStart(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.start_date.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.start_date,
                    ),
                );

                setCompareEnd(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.end_date.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.end_date,
                    ),
                );

                setCompareCreated(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.createdAt.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.created_at,
                    ),
                );

                setCompareUsingStart(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.using_start_date.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]
                            ?.using_start_date,
                    ),
                );

                setCompareUsingEnd(
                    getDefaultCompare(
                        SEARCH_FIELD_TYPES.using_end_date.name,
                        props.getParams,
                        props.globalSearch.search[searchEntity]?.using_end_date,
                    ),
                );
            }
        }, [props.globalSearch]);

        /**
         * Gets array for Select element of Material UI from schema
         *
         * @param {string} entity
         * @param {string} field
         */
        // Кастомизация селекта, добавление не стандартных полей
        const getArrFromSchema = (entity, field, interfaces = null) => {
            if (!field) {
                return [{ Активные: 1 }, { Неактивные: 0 }];
            }

            if (entity === "purchased_services" && field === "") {
                return;
            }

            const arrForSelect = [];

            if (
                field === "order_source" &&
                props?.user?.type === "manager_export"
            ) {
                if (props?.user?.places_sales?.length > 0) {
                    props?.user?.places_sales
                        ?.filter((p) => p.active)
                        ?.forEach((p) => {
                            arrForSelect.push({ [p.name]: p.name });
                        });
                }
                return arrForSelect;
            }

            const fields =
                entity === "subscriptions"
                    ? subscriptionsFields
                    : entity === "purchased_services"
                      ? purchasedServicesFields
                      : entity === "reservations"
                        ? reservationsFields
                        : entity === "reservations_asu"
                          ? reservationsASUFields
                          : entity === "message_logs"
                            ? messageLogsFields
                            : entity === "refund"
                              ? refundFields
                              : usersFields;
            if (entity === "message_logs" && field !== "status") {
                if (field === "message_type" && interfaces?.[1]) {
                    interfaces[1].forEach((i) => arrForSelect.push({ [i]: i }));
                } else if (field === "interface_name" && interfaces?.[0]) {
                    interfaces[0].forEach((i) => arrForSelect.push({ [i]: i }));
                }
            } else if (entity === "reservations_asu") {
                const fieldToProp = {
                    status_code: "statusCodes",
                    rate_code: "rateCodes",
                    room_type_code: "roomTypesCodes",
                    order_source: "orderSources"
                };

                const propName = fieldToProp[field];
                const sourceArray = props?.inputFilter?.[propName] ?? [];

                if (sourceArray.length > 0) {
                    arrForSelect.push(...sourceArray.map(i => ({ [i]: i })));
                }
                return arrForSelect;
            } else {
                for (const [key, value] of Object.entries(
                    fields[[field]]?.values,
                )) {
                    arrForSelect.push({ [value]: key });
                }
            }

            return arrForSelect;
        };

        const handleChangeSearchField = (fieldData) => {
            if (!fieldData) return;

            const { name, value } = fieldData;

            let searchParamObj = props.globalSearch.search[searchEntity];

            // if (props.getParams) {
            //     // For proper order
            //     const updatedGetParams = { ...props.getParams };
            //
            //         if (!isNaN(updatedGetParams.page))
            //             updatedGetParams.page = updatedGetParams.page.toString();
            //
            //     searchParamObj = {
            //         ...searchParamObj,
            //         ...updatedGetParams
            //     };
            // }

            if ((name && value) || (name && value === 0)) {
                let valueSuper = value;
                if (name === "created_at") {
                    valueSuper = createCompareValue(value, compareCreated);
                }
                if (["date_in", "date_start", "start_date"].includes(name)) {
                    valueSuper = createCompareValue(value, compareStart);
                }
                if (["date_out", "date_end", "end_date"].includes(name)) {
                    valueSuper = createCompareValue(value, compareEnd);
                }
                if (["using_start_date"].includes(name)) {
                    valueSuper = createCompareValue(value, compareUsingStart);
                }
                if (["using_end_date"].includes(name)) {
                    valueSuper = createCompareValue(value, compareUsingEnd);
                }
                if (name === "total") {
                    valueSuper = createCompareValue(value, compareCheck);
                }
                searchParamObj = {
                    ...searchParam,
                    [name]: valueSuper.toString(),
                };

                if (
                    (name === SEARCH_FIELD_TYPES.status.name && !value) ||
                    (name === SEARCH_FIELD_TYPES.roomTypeId.name && !value)
                ) {
                    searchParamObj = {};
                    fieldData = {};
                }
            } else if (
                name &&
                !value &&
                Object.keys(searchParam)?.length <= 1
            ) {
                fieldData = {};
                searchParamObj = props.globalSearch.search[searchEntity];
            } else if (name && !value && Object.keys(searchParam)?.length > 1) {
                searchParamObj = { ...searchParam };
                searchParamObj[[name]] = "";
            }

            if (props.getParams) {
                for (const key in searchParamObj) {
                    if (
                        searchParamObj[key] === undefined ||
                        !searchParamObj[key]?.includes
                    )
                        continue;
                    if (
                        COMPARE_STRINGS_ARR.some((str) =>
                            searchParamObj[key].includes(str),
                        )
                    ) {
                        const [valStr] = formatValueWithCompareStr(
                            searchParamObj[key],
                        );

                        switch (key) {
                            case SEARCH_FIELD_TYPES.createdAt.name:
                                setCreatedAtDate(valStr);
                                break;
                            case SEARCH_FIELD_TYPES.dateIn.name:
                                setStartDate(valStr);
                                break;
                            case SEARCH_FIELD_TYPES.dateOut.name:
                                setEndDate(valStr);
                                break;
                            case SEARCH_FIELD_TYPES.start_date.name:
                                setStartDate(valStr);
                                break;
                            case SEARCH_FIELD_TYPES.end_date.name:
                                setEndDate(valStr);
                                break;
                            case SEARCH_FIELD_TYPES.using_start_date.name:
                                setUsingStartDate(valStr);
                                break;
                            case SEARCH_FIELD_TYPES.using_end_date.name:
                                setUsingEndDate(valStr);
                                break;
                        }
                    }
                }
            }

            setSavedParams(fieldData);
            setSearchParam(searchParamObj);

            props.updateGlobalSearch(searchParamObj, searchEntity);
        };

        useEffect(
            () => handleChangeSearchField(savedParams),
            [
                compareCheck,
                compareStart,
                compareEnd,
                compareCreated,
                compareUsingStart,
                compareUsingEnd,
            ],
        );

        const searchFields = createSearchFields(
            searchEntity,
            startDate,
            endDate,
            createdAtDate,
            compareCheck,
            compareStart,
            compareEnd,
            compareCreated,
            COMPARE_VALUES,
            props.roomTypes,
            props.rates,
            props.hotelsData,
            searchParam,
            handleChangeSearchField,
            changeCompare,
            changeDate,
            setStartDate,
            setEndDate,
            setCreatedAtDate,
            setCompareCheck,
            setCompareStart,
            setCompareEnd,
            setCompareCreated,
            prepareForSelectEl,
            getArrFromSchema,
            createTextField,
            createSelectElem,
            createDatePicker,
            createLookup,
            usingStartDate,
            usingEndDate,
            setUsingStartDate,
            setUsingEndDate,
            props.interfaces,
            compareUsingStart,
            compareUsingEnd,
            setCompareUsingStart,
            setCompareUsingEnd,
            props.serviceCategories,
        );

        let defaultSearchparams = props.globalSearch.search[searchEntity];

        if (props.getParams) {
            const getParamsFields = Object.keys(DEFAULT_GET_PARAMS);
            const currentGetParams = { ...DEFAULT_GET_PARAMS };
            getParamsFields.forEach(
                (field) => (currentGetParams[field] = props.getParams[field]),
            );
            defaultSearchparams = {
                ...SEARCH_FIELDS_DEFAULT[searchEntity],
                ...currentGetParams,
            };
        }

        const searchElem = searchFields?.length > 0 && (
            <div
                style={{
                    display: "flex",
                    position: "relative",
                    maxWidth: "max-content",
                    flexDirection: searchFields?.length > 3 ? "column" : "row",
                    padding: 16,
                    gap: 16,
                }}
            >
                <div className={styles.grid__container}>
                    {searchFields
                        .filter((field) => !!field)
                        .map((field) => (
                            <div key={field.name} className={styles.grid__item}>
                                {field}
                            </div>
                        ))}
                </div>
                <Box
                    style={{
                        display: "flex",
                        alignItems:
                            searchFields?.length > 3 ? "flex-end" : "center", // justifyContent: searchFields.length > 3 ? 'flex-end' : 'flex-start',
                        flex: 1,
                        gap: 16,
                    }}
                >
                    {createButton(
                        buttonTypes.dropFilters,
                        initiateSearch,
                        setSearchParam,
                        searchEntity,
                        defaultSearchparams,
                        compareCheck,
                        compareStart,
                        compareEnd,
                        compareCreated,
                        props.initSearch,
                        props.searchItemsAction,
                        searchEntity,
                        setStartDate,
                        setEndDate,
                        setCreatedAtDate,
                        setSavedParams,
                        props.updateGlobalSearch,
                        props.globalSearch,
                        compareUsingStart,
                        compareUsingEnd,
                        setUsingStartDate,
                        setUsingEndDate,
                    )}
                    {createButton(
                        buttonTypes.startSearch,
                        initiateSearch,
                        setSearchParam,
                        searchEntity,
                        searchParam,
                        compareCheck,
                        compareStart,
                        compareEnd,
                        compareCreated,
                        props.initSearch,
                        props.searchItemsAction,
                        searchEntity,
                        null,
                        null,
                        null,
                        null,
                        props.updateGlobalSearch,
                        props.globalSearch,
                        compareUsingStart,
                        compareUsingEnd,
                        setUsingStartDate,
                        setUsingEndDate,
                    )}
                </Box>
            </div>
        );

        return searchElem;
    }
    return null;
};

//Helper funcs

/**
 * Gets default value for compare el state
 * @param {Object} getPars
 * @returns selected compare value
 */
const getDefaultCompare = (comparedField, getPars, saveCompare = null) => {
    if (saveCompare) {
        const operator = saveCompare.split(":")[0];

        for (let i = 0; i < COMPARE_VALUES.length; i++) {
            const e = COMPARE_VALUES[i];
            for (const key in e) {
                if (operator == e[key].split(":")[0]) {
                    return COMPARE_VALUES[i];
                }
            }
        }
    }

    if (
        getPars &&
        Object.keys(getPars).some((par) => ENTITIES_WITH_COMPARE.includes(par))
    ) {
        for (const key in getPars) {
            if (comparedField === key) {
                const compareVal = formatValueWithCompareStr(getPars[key])[1];
                const compareIdx = COMPARE_VALUES.findIndex((val) =>
                    Object.values(val).includes(compareVal),
                );
                return COMPARE_VALUES[compareIdx];
            }
        }
    }
    return COMPARE_VALUES[0];
};

/**
 * Parces value to get value without compare strings
 * @param {string} value
 * @returns value and compare string
 */
const formatValueWithCompareStr = (value) => {
    const valueArr = value.split(":");
    return [valueArr[valueArr.length - 1], valueArr[0] + ":"];
};

/**
 * Format comparable value before usage to prevent errors
 * @param {string} value
 * @param {Object} compareValues
 * @returns formatted value
 */
const createCompareValue = (value, compareValues) => {
    if (value.includes(compareValues[Object.keys(compareValues)[0]])) {
        return value;
    }
    if (COMPARE_STRINGS_ARR.some((compareStr) => value.includes(compareStr))) {
        return (
            compareValues[Object.keys(compareValues)[0]] +
            formatValueWithCompareStr(value)[0]
        );
    }
    return compareValues[Object.keys(compareValues)[0]] + value;
};

/**
 * Prepares values and starts searching
 *
 * @param {string} entity
 * @param {string} params
 * @param {Object} compareVal
 * @param {Object} compareStartVal
 * @param {Object} compareEndVal
 * @param {Object} compareCreatedVal
 * @param {function} initSearch
 * @param {function} searchFront
 * @param {function} cancelStartDate
 * @param {function} cancelEndDate
 * @param {function} cancelCreatedAtDate
 */

const initiateSearch = (
    entity,
    params,
    compareVal,
    compareStartVal,
    compareEndVal,
    compareCreatedVal,
    switchSearchValues,
    initSearch,
    searchFront,
    cancelStartDate,
    cancelEndDate,
    cancelCreatedAtDate,
    setSavedField,
    searchEntity,
    proper,
    updateGlobalSearch,
    globalSearch,
    compareUsingStart,
    compareUsingEnd,
    setUsingStartDate,
    setUsingEndDate,
) => {
    if (!params) return;
    const searchValuesOnly = { ...params };
    if (
        Object.keys(searchValuesOnly).some((value) =>
            Object.keys(DEFAULT_GET_PARAMS).includes(value),
        )
    ) {
        for (let key in searchValuesOnly) {
            Reflect.deleteProperty(searchValuesOnly, key);
        }
    }

    let filterredParams = {};
    const valuesArr = Object.values(searchValuesOnly);

    let isDefaultValues = valuesArr.every((searchVal) => !searchVal);

    if (
        cancelStartDate &&
        cancelEndDate &&
        cancelCreatedAtDate &&
        setSavedField
    ) {
        cancelStartDate(null);
        cancelEndDate(null);
        cancelCreatedAtDate(null);
        setSavedField();
    }

    for (let [key, value] of Object.entries(params)) {
        if (params[key] || params[key] === 0) {
            if (key === "guest") {
                value = value.replace(REGEX_FOR_MULTIPLE_SPACES, " ").trim();
            } else {
                if (
                    ![
                        "status_code",
                        "rate_code",
                        "room_type_code",
                        "order_source",
                    ].includes(key)
                ) {
                    value = value.replace(REGEX_FOR_ALL_BLANKS, "");
                }
            }

            if (ENTITIES_WITH_COMPARE.includes(key)) {
                switch (key) {
                    case SEARCH_FIELD_TYPES.dateStart.name:
                    case SEARCH_FIELD_TYPES.start_date.name:
                    case SEARCH_FIELD_TYPES.dateIn.name:
                        filterredParams[key] = createCompareValue(
                            value,
                            compareStartVal,
                        );
                        break;
                    case SEARCH_FIELD_TYPES.using_start_date.name:
                        filterredParams[key] = createCompareValue(
                            value,
                            compareUsingStart,
                        );
                        break;
                    case SEARCH_FIELD_TYPES.dateEnd.name:
                    case SEARCH_FIELD_TYPES.end_date.name:
                    case SEARCH_FIELD_TYPES.dateOut.name:
                        filterredParams[key] = createCompareValue(
                            value,
                            compareEndVal,
                        );
                        break;
                    case SEARCH_FIELD_TYPES.using_end_date.name:
                        filterredParams[key] = createCompareValue(
                            value,
                            compareUsingEnd,
                        );
                        break;
                    case SEARCH_FIELD_TYPES.createdAt.name:
                        filterredParams[key] = createCompareValue(
                            value,
                            compareCreatedVal,
                        );
                        break;
                    default:
                        filterredParams[key] = createCompareValue(
                            value,
                            compareVal,
                        );
                }
            } else {
                filterredParams[key] = value;
            }
        }
    }

    switch (entity) {
        case "purchased_services":
            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                initSearch(
                    filterEmptyValues(globalSearch.search.purchased_services),
                );
            }
            break;
        case "message_logs":
            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                initSearch(filterEmptyValues(globalSearch.search.message_logs));
            }
            break;
        case "reservations":
            filterredParams.page = globalSearch.search.reservations.page;
            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                const merged = getMergedParams(
                    DEFAULT_GET_PARAMS,
                    filterredParams,
                );
                if (filterredParams?.status === undefined) {
                    delete merged.status;
                }

                initSearch(merged);
            }
            break;
        case "reservations_asu":
            filterredParams.page = globalSearch.search.reservations.page;
            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                const merged = getMergedParams(
                    DEFAULT_GET_PARAMS,
                    filterredParams,
                );
                if (filterredParams?.status === undefined) {
                    delete merged.status;
                }

                initSearch(merged);
            }
            break;
        case "refund":
            filterredParams.page = globalSearch.search.refund.page;
            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                const merged = getMergedParams(
                    DEFAULT_GET_PARAMS,
                    filterredParams,
                );
                if (filterredParams?.status === undefined) {
                    delete merged.status;
                }

                initSearch(merged);
            }
            break;
        case "subscriptions":
            filterredParams.page = globalSearch.search.subscriptions.page;

            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                const merged = getMergedParams(
                    DEFAULT_GET_PARAMS,
                    filterredParams,
                );
                if (filterredParams?.status === undefined) {
                    delete merged.status;
                }

                initSearch(merged);
            }
            break;
        case "rates":
        case "promo":
            filterredParams.page = DEFAULT_GET_PARAMS_RATES_AND_SERVICES.page;
            if (proper === "Сбросить") {
                setUsingStartDate(null);
                setUsingEndDate(null);
                properFilter(
                    DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                isDefaultValues = false;
            } else {
                initSearch(
                    getMergedParams(
                        DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
                        filterredParams,
                    ),
                );
            }
            break;
        case "services":
            filterredParams.page = DEFAULT_GET_PARAMS_RATES_AND_SERVICES.page;
            if (proper === "Сбросить") {
                properFilter(
                    DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
                    SEARCH_FIELDS_DEFAULT,
                    searchEntity,
                    initSearch,
                    updateGlobalSearch,
                    globalSearch,
                    switchSearchValues,
                );
                searchFront(filterredParams);
                isDefaultValues = false;
            } else {
                // initSearch(getMergedParams(DEFAULT_GET_PARAMS_RATES_AND_SERVICES, filterredParams));
                searchFront(
                    getMergedParams(
                        DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
                        filterredParams,
                    ),
                );
            }
            break;
        default:
            searchFront(filterredParams);
    }

    if (isDefaultValues) {
        switchSearchValues(params);
    }
};

/**
 * Get search entity
 *
 * @param {string} path
 */

const getSearchEntity = (path) => {
    const pathArr = path.split("/");
    let entity = pathArr[pathArr.length - 1];
    if (pathArr.includes("users") && pathArr.length > 2) {
        entity = "operators";
    }
    return entity;
};

/**
 * Formates date for search
 *
 * @param {moment} dateMoment
 */

const formatDate = (dateMoment) => {
    if (moment.isMoment(dateMoment)) {
        return dateMoment.format(STATE_DATE_FORMAT);
    }
};

/**
 * Change date
 *
 * @param {moment} date
 * @param {string} dateType
 * @param {function} changeSearchValue
 * @param {function} setChangedDate
 */

const changeDate = (date, dateType, changeSearchValue, setChangedDate) => {
    const formattedDate = formatDate(date);
    setChangedDate(date);
    changeSearchValue({ name: dateType, value: formattedDate });
};

/**
 * Renders change compare element
 *
 * @param {Object} curCompareVal
 * @param {Array} compareValArr
 * @param {function} setCompareVal
 */

const changeCompare = (curCompareVal, compareValArr, setCompareVal) => {
    const curCompareIndex = compareValArr.findIndex(
        (elem) =>
            elem[Object.keys(curCompareVal)[0]] ===
            curCompareVal[Object.keys(curCompareVal)[0]],
    );

    let nextElIndex = curCompareIndex + 1;

    if (curCompareIndex === compareValArr.length - 1) {
        nextElIndex = 0;
    }

    setCompareVal(compareValArr[nextElIndex]);
};

/**
 * Creates button with parameters
 *
 * @param {string} buttonType
 * @param {function} startAction
 * @param {function} changeSearchValues
 * @param {string} entity
 * @param {Object} param
 * @param {Object} compareVal
 * @param {Object} compareStartDate
 * @param {Object} compareEndtDate
 * @param {Object} compareCreatedDate
 * @param {function} initSearch
 * @param {function} outerSearchAction
 * @param {function} setStartDate
 * @param {function} setEndDate
 * @param {function} setCreatedAtDate
 */

const createButton = (
    buttonType,
    startAction,
    changeSearchValues,
    entity,
    param,
    compareVal,
    compareStartDate,
    compareEndtDate,
    compareCreatedDate,
    initSearch,
    outerSearchAction,
    searchEntity,
    setStartDate,
    setEndDate,
    setCreatedAtDate,
    setSavedField,
    updateGlobalSearch,
    globalSearch,
    compareUsingStart,
    compareUsingEnd,
    setUsingStartDate,
    setUsingEndDate,
) => (
    <Button
        variant={MATERIAL_UI_PROPS.varinats.contained}
        size={MATERIAL_UI_PROPS.sizes.medium}
        color={buttonType.color}
        style={{
            backgroundColor: buttonType.backgroundColor,
            color: buttonType.color,
            borderRadius: 8,
            width: buttonType.width,
            margin: buttonType.margin,
        }}
        className={styles.button__search}
        onClick={() =>
            startAction(
                entity,
                param,
                compareVal,
                compareStartDate,
                compareEndtDate,
                compareCreatedDate,
                changeSearchValues,
                initSearch,
                outerSearchAction,
                setStartDate,
                setEndDate,
                setCreatedAtDate,
                setSavedField,
                searchEntity,
                buttonType.name,
                updateGlobalSearch,
                globalSearch,
                compareUsingStart,
                compareUsingEnd,
                setUsingStartDate,
                setUsingEndDate,
            )
        }
    >
        {buttonType.name}
    </Button>
);

/**
 * Creates Textfield from Material UI
 *
 * @param {string} name
 * @param {string} placeholderName
 * @param {string} searchValue
 * @param {function} changeSearchValue
 * @param {object} styling
 * @param {object} compareVal
 * @param {function} changeCompareVal
 * @param {function} setCompareVal
 */

const createTextField = (
    name,
    placeholderName,
    searchValue,
    changeSearchValue,
    styling,
    compareVal,
    compareValArr,
    changeCompareVal,
    setCompareVal,
) => (
    <span
        key={name}
        style={{
            display: "flex",
            width: "100%",
        }}
    >
        {changeCompareVal && (
            <IconButton
                title={compareVal.title}
                style={{ padding: "0px 7px" }}
                size={MATERIAL_UI_PROPS.sizes.medium}
                onClick={() => {
                    changeCompareVal(compareVal, compareValArr, setCompareVal);
                }}
            >
                {Object.keys(compareVal)[0]}
            </IconButton>
        )}
        <TextField
            style={{
                width: "100%",
                minWidth: "290px",
                ...styling,
            }}
            size={styling.size}
            label={placeholderName}
            value={searchValue}
            name={name}
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            onChange={(e) => changeSearchValue(e.target)}
        />
    </span>
);

/**
 * Creates Select Element from Material UI
 *
 * @param {string} name
 * @param {string} labelName
 * @param {string} curVal
 * @param {array} values
 * @param {function} changeSearchValue
 * @param {object} styling
 */

const createSelectElem = (
    name,
    labelName,
    curVal,
    values,
    changeSearchValue,
    styling,
) => {
    const menuItems = [
        <MenuItem key="All" value="">
            Все
        </MenuItem>,
    ];

    if (name === "hidden") values = [{ Скрытые: 1 }, { Открытые: 0 }];

    if (name === "inherited") values = [{ Базовый: 0 }, { Наследованный: 1 }];

    values.forEach((valueObj) => {
        let menuItem;
        for (const [key, value] of Object.entries(valueObj)) {
            menuItem = (
                <MenuItem key={key} value={value}>
                    {key}
                </MenuItem>
            );
            menuItems.push(menuItem);
        }
    });

    return (
        <FormControl
            key={`control-${name}`}
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            size={MATERIAL_UI_PROPS.sizes.small}
            style={{
                width: "100%",
            }}
        >
            <InputLabel key="inputLabel" htmlFor="select-label">
                {labelName}
            </InputLabel>
            <Select
                key="select"
                name={name}
                label={labelName}
                id="select-label"
                value={curVal}
                onChange={(e) => changeSearchValue(e.target)}
            >
                {menuItems}
            </Select>
        </FormControl>
    );
};

/**
 * Creates Datepicker element from Material UI
 *
 * @param {string} name
 * @param {moment} dateValue
 * @param {function} changeDateValueFunc
 * @param {function} setDateValue
 * @param {function} changeSearchValueFunc
 * @param {string} labelValue
 * @param {Object} styling
 * @param {Object} compareVal
 * @param {function} setCompareVal
 * @param {function} compareValArr
 * @param {function} changeCompareVal
 */

const createDatePicker = (
    name,
    dateValue,
    changeDateValueFunc,
    setDateValue,
    changeSearchValueFunc,
    labelValue,
    styling,
    compareVal,
    setCompareVal,
    compareValArr,
    changeCompareVal,
) => {
    return (
        compareVal && (
            <span
                key={name}
                style={{
                    display: "flex",
                }}
            >
                <IconButton
                    key={`compare ${name}`}
                    title={compareVal?.title}
                    style={{ padding: "0px 7px" }}
                    onClick={() => {
                        changeCompareVal(
                            compareVal,
                            compareValArr,
                            setCompareVal,
                        );
                    }}
                >
                    {Object.keys(compareVal)[0]}
                </IconButton>
                <MuiPickersUtilsProvider
                    libInstance={moment}
                    utils={MomentUtils}
                    locale={client.locale}
                >
                    <KeyboardDatePicker
                        label={labelValue}
                        style={{
                            width: "100%",
                            minWidth: "290px",
                        }}
                        variant={MATERIAL_UI_PROPS.varinats.inline}
                        size={styling.size}
                        format={SHOW_DATE_FORMAT}
                        invalidDateMessage="Некорректная форма даты"
                        value={dateValue}
                        inputVariant={MATERIAL_UI_PROPS.varinats.outlined}
                        onChange={(date) =>
                            changeDateValueFunc(
                                date,
                                name,
                                changeSearchValueFunc,
                                setDateValue,
                            )
                        }
                    />
                </MuiPickersUtilsProvider>
            </span>
        )
    );
};

/**
 * Creates Material UI Autocomplete Element
 *
 * @param {array} optionsArr
 * @param {string} searchField
 * @param {string} label
 * @param {string} curVal
 * @param {function} changeSearchValue
 * @param {object} styling
 */

const createLookup = (
    searchField,
    optionsArr,
    label,
    changeSearchValue,
    styling,
) => {
    if (!optionsArr) return;

    const optsToWork = optionsArr.map((option) => ({
        ...option,
        key: option.id,
    }));

    return (
        <Autocomplete
            key={searchField}
            options={optsToWork}
            style={{
                width: "100%",
            }}
            size={styling.size}
            name={searchField}
            label={label}
            getOptionSelected={(option) => option.name}
            getOptionLabel={(option) => option.name}
            onChange={(e) =>
                changeSearchValue({
                    name: searchField,
                    value: e.target.textContent,
                })
            }
            clearOnBlur
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant={MATERIAL_UI_PROPS.varinats.outlined}
                />
            )}
        ></Autocomplete>
    );
};

/**
 * Converts array of objects for Material UI Select element
 *
 * @param {array} valuesArr
 */

const prepareForSelectEl = (valuesArr) =>
    valuesArr.map((valObj) => ({
        [valObj.name]: valObj.id,
    }));

/**
 * Creates search fields for filter
 *
 * @param {string} entity
 * @param {moment} startDate
 * @param {moment} endDate
 * @param {moment} createdAtDate
 * @param {object} compareValue
 * @param {array} roomTypesFromBack
 * @param {array} hotelsDataFromBack
 * @param {array} compareValuesArr
 * @param {function} changeSearchValue
 * @param {function} changeCompareValue
 * @param {function} changeDate
 * @param {function} setStartDate
 * @param {function} setEndDate
 * @param {function} setCreatedAtDate
 * @param {function} setCompareValue
 * @param {function} formatForSelectEl
 * @param {function} getArrFromSchema
 * @param {function} createTextFieldEl
 * @param {function} createSelectEl
 * @param {function} createDatePicker
 * @param {function} createLookupEl
 */

const createSearchFields = (
    entity,
    startDate,
    endDate,
    createdAtDate,
    compareValue,
    compareStartValue,
    compareEndValue,
    compareCreatedValue,
    compareValuesArr,
    roomTypesFromBack = [],
    rateTypesFromBack = [],
    hotelsDataFromBack,
    searchValues,
    changeSearchValue,
    changeCompareValue,
    changeDate,
    setStartDate,
    setEndDate,
    setCreatedAtDate,
    setCompareValue,
    setCompareStartValue,
    setCompareEndValue,
    setCompareCreatedValue,
    formatForSelectEl,
    getArrFromSchema,
    createTextFieldEl,
    createSelectEl,
    createDatePicker,
    createLookupEl,
    usingStartDate,
    usingEndDate,
    setUsingStartDate,
    setUsingEndDate,
    interfaces,
    compareUsingStart,
    compareUsingEnd,
    setCompareUsingStart,
    setCompareUsingEnd,
    serviceCategories,
) => {
    const commonStyling = {
        size: MATERIAL_UI_PROPS.sizes.small,
        borderRadius: "30px",
    };
    const fieldsArr = [];

    if (searchValues) {
        for (let [key, value] of Object.entries(searchValues)) {
            if (value === undefined || !value?.includes) continue;

            if (
                COMPARE_STRINGS_ARR.some((compareStr) =>
                    value.includes(compareStr),
                )
            ) {
                value = formatValueWithCompareStr(value)[0];
            }

            let field;
            switch (key) {
                case SEARCH_FIELD_TYPES.name.name:
                    field = createTextFieldEl(
                        key,
                        entity == "subscriptions"
                            ? "Имя гостя"
                            : SEARCH_FIELD_TYPES.name.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.reservation_number.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.reservation_number.label[
                            client.locale
                        ],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.active.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.active.label[client.locale],
                        value,
                        getArrFromSchema(),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.purchased_status.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.purchased_status.label[
                            client.locale
                        ],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.category_services.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.category_services.label[
                            client.locale
                        ],
                        value,
                        serviceCategories,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.hidden.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.hidden.label[client.locale],
                        value,
                        getArrFromSchema(),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.inherited.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.inherited.label[client.locale],
                        value,
                        getArrFromSchema(),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.dateStart.name:
                    field = createDatePicker(
                        key,
                        startDate,
                        changeDate,
                        setStartDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.dateStart.label[client.locale],
                        commonStyling,
                        compareStartValue,
                        setCompareStartValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.start_date.name:
                    field = createDatePicker(
                        key,
                        startDate,
                        changeDate,
                        setStartDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.start_date.label[client.locale],
                        commonStyling,
                        compareStartValue,
                        setCompareStartValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.dateEnd.name:
                    field = createDatePicker(
                        key,
                        endDate,
                        changeDate,
                        setEndDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.dateEnd.label[client.locale],
                        commonStyling,
                        compareEndValue,
                        setCompareEndValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.end_date.name:
                    field = createDatePicker(
                        key,
                        endDate,
                        changeDate,
                        setEndDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.end_date.label[client.locale],
                        commonStyling,
                        compareEndValue,
                        setCompareEndValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.using_start_date.name:
                    field = createDatePicker(
                        key,
                        usingStartDate,
                        changeDate,
                        setUsingStartDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.using_start_date.label[
                            client.locale
                        ],
                        commonStyling,
                        compareUsingStart,
                        setCompareUsingStart,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.using_end_date.name:
                    field = createDatePicker(
                        key,
                        usingEndDate,
                        changeDate,
                        setUsingEndDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.using_end_date.label[client.locale],
                        commonStyling,
                        compareUsingEnd,
                        setCompareUsingEnd,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.createdAt.name:
                    field = createDatePicker(
                        key,
                        createdAtDate,
                        changeDate,
                        setCreatedAtDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.createdAt.label[client.locale],
                        commonStyling,
                        compareCreatedValue,
                        setCompareCreatedValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.number.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.number.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.order_number.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.order_number.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.reservation_id.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.reservation_id.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.promo_code.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.promo_code.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.guest.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.guest.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.dateIn.name:
                    field = createDatePicker(
                        key,
                        startDate,
                        changeDate,
                        setStartDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.dateIn.label[client.locale],
                        commonStyling,
                        compareStartValue,
                        setCompareStartValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.dateOut.name:
                    field = createDatePicker(
                        key,
                        endDate,
                        changeDate,
                        setEndDate,
                        changeSearchValue,
                        SEARCH_FIELD_TYPES.dateOut.label[client.locale],
                        commonStyling,
                        compareEndValue,
                        setCompareEndValue,
                        compareValuesArr,
                        changeCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.roomTypeId.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.roomTypeId.label[client.locale],
                        value,
                        formatForSelectEl(roomTypesFromBack),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.rate.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.rate.label[client.locale],
                        value,
                        formatForSelectEl(rateTypesFromBack),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.status.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.status.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.status_pms.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.status_pms.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.status_code.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.status_code.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.rate_code.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.rate_code.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.room_type_code.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.room_type_code.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.order_source.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.order_source.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.total.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.total.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                        compareValue,
                        compareValuesArr,
                        changeCompareValue,
                        setCompareValue,
                    );
                    break;
                case SEARCH_FIELD_TYPES.login.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.login.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.type.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.type.label[client.locale],
                        value,
                        getArrFromSchema(entity, key),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.email.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.email.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.hotels.name:
                    field = createLookupEl(
                        key,
                        hotelsDataFromBack,
                        SEARCH_FIELD_TYPES.hotels.label[client.locale],
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.firstName.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.firstName.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.lastName.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.lastName.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.entity_id.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.entity_id.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.message_type.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.message_type.label[client.locale],
                        value,
                        getArrFromSchema(entity, key, interfaces),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.id.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.id.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.guest_phone.name:
                    field = createTextFieldEl(
                        key,
                        SEARCH_FIELD_TYPES.guest_phone.label[client.locale],
                        value,
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                case SEARCH_FIELD_TYPES.interface_name.name:
                    field = createSelectEl(
                        key,
                        SEARCH_FIELD_TYPES.interface_name.label[client.locale],
                        value,
                        getArrFromSchema(entity, key, interfaces),
                        changeSearchValue,
                        commonStyling,
                    );
                    break;
                default:
                    field = null;
            }
            fieldsArr.push(field);
        }
    }
    return fieldsArr;
};

// удаляем пустые параметры
const filterEmptyValues = (searchParam) => {
    const filteredParam = {};
    for (const key in searchParam) {
        const value = searchParam[key];
        if (value !== "") {
            filteredParam[key] = value;
        }
    }
    return filteredParam;
};

// обновляем getParams
const getMergedParams = (getParams, searchParam) => {
    const mergedParams = { ...getParams };

    for (const key in filterEmptyValues(searchParam)) {
        if (mergedParams.hasOwnProperty(key)) {
            mergedParams[key] = filterEmptyValues(searchParam)[key];
        } else {
            mergedParams[key] = filterEmptyValues(searchParam)[key];
        }
    }
    return mergedParams;
};

// действия кнопки сбросить
const properFilter = (
    defaultParams,
    SEARCH_FIELDS_DEFAULT,
    searchEntity,
    initSearch,
    updateGlobalSearch,
    globalSearch,
    switchSearchValues,
) => {
    // установка в фильтры setSearchParam
    switchSearchValues(SEARCH_FIELDS_DEFAULT[searchEntity]);

    // запуск поиска initSearch
    initSearch(
        getMergedParams(defaultParams, SEARCH_FIELDS_DEFAULT[searchEntity]),
    );

    updateGlobalSearch(SEARCH_FIELDS_DEFAULT[searchEntity], searchEntity);
};

FilterComponent.propTypes = {
    pathname: PropTypes.string,
    initSearch: PropTypes.func,
    searchItemsAction: PropTypes.func,
    getParams: PropTypes.object,
};

export default memo(FilterComponent);

const startingParameter = (globalSearch, variant, searchEntity) => {
    if (variant === "usingStart")
        return (
            globalSearch[searchEntity].using_start_date?.split(":")[1] ?? null
        );
    if (variant === "usingEnd")
        return globalSearch[searchEntity].using_end_date?.split(":")[1] ?? null;
    if (variant === "created")
        return globalSearch[searchEntity].created_at?.split(":")[1] ?? null;

    switch (searchEntity) {
        case "subscriptions":
        case "reservations":
        case "reservations_asu":
            switch (variant) {
                case "start":
                    return (
                        globalSearch[searchEntity].date_in?.split(":")[1] ??
                        null
                    );
                case "end":
                    return (
                        globalSearch[searchEntity].date_out?.split(":")[1] ??
                        null
                    );
            }
            break;
        case "promo":
            switch (variant) {
                case "start":
                    return (
                        globalSearch[searchEntity].start_date?.split(":")[1] ??
                        null
                    );
                case "end":
                    return (
                        globalSearch[searchEntity].end_date?.split(":")[1] ??
                        null
                    );
            }
            break;
        case "rates":
            switch (variant) {
                case "start":
                    return (
                        globalSearch[searchEntity].date_start?.split(":")[1] ??
                        null
                    );
                case "end":
                    return (
                        globalSearch[searchEntity].date_end?.split(":")[1] ??
                        null
                    );
            }
            break;
    }
};
